import { useQuery } from '@tanstack/react-query'
import { listChannelInstances, type ChannelInstanceResponse } from '@/services/channelsApi'
import { queryKeys } from '@/lib/queryKeys'
import { useAuthStore } from '@/store/authStore'

/** Canales del negocio: dashboard, centro de atención y checklist comparten esta consulta. */
export function useChannelInstances() {
  const tenantId = useAuthStore((state) => state.tenantId)

  return useQuery<ChannelInstanceResponse[]>({
    queryKey: queryKeys.instances(tenantId),
    queryFn: listChannelInstances,
    enabled: Boolean(tenantId),
    staleTime: 60_000,
    refetchIntervalInBackground: false,
  })
}
